(function($, undefined) {
	'use strict';
	let formValidator;
	let itemId;
	var init = function() {
		formValidator = Fw.component.models().form;
		const geolocationForm = $('#geolocation-form');
		const btn = geolocationForm.find('.btn-processing');
		const errorMsg = $('.add-modify-page-inner-item-ctn__error');

		$("form#geolocation-form :input").each(function(){
			var input = $(this); 
			input.on('change', () => {
				if (input.val()) {
					errorMsg.hide(300);
				}
			});
		});

		geolocationForm.on('submit', () => {
			formValidator.validateForm(geolocationForm);
			btn.addClass('btn-processing_active');
			if (geolocationForm.hasClass('has-error')) {
				btn.removeClass('btn-processing_active');
				errorMsg.show(300);
				return false;
			}
		});
	};
  
	$(window).ready(function() {
	  init();
	});
  })(jQuery);
  